import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import GenericMessage from '@atlassian/bitbucket-generic-message';

import { useMatch } from 'src/router/hooks';

import { messages } from './no-files-message.i18n';

const NoFilesMessage = (): JSX.Element => {
  const prPath =
    '/:repositoryOwner/:repositorySlug/pull-requests/:pullRequestId';
  const { path } = useMatch();
  const currentPage = path === prPath ? 'pull request' : 'commit';
  return (
    <GenericMessage
      iconType="info"
      title={<FormattedMessage {...messages.noFilesTitle} />}
    >
      <FormattedMessage
        tagName="p"
        {...messages.noFiles}
        values={{ context: currentPage }}
      />
    </GenericMessage>
  );
};

export default NoFilesMessage;
